import CustomTable from "../../../components/CustomTable";

export default function Attendance(props) {
    return <CustomTable records={props.records} title='Attendance Records' recordsPerPage={10} />
}